const SpaceHolderRendererHelper = (props) => {
  const { spaceHolderValue } = props
  return spaceHolderValue
}

export default SpaceHolderRendererHelper
